// FormikDropdown.tsx
import React from 'react';
import { useField } from 'formik';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';

interface Option {
  value: string | number;
  label: string;
}

interface FormikDropdownProps {
  name: string;
  options: Option[];
  label?: string;
  placeholder?: string;
  className?: string;
  onChange?: (value: string | number) => void;
}

export const FormikDropdown: React.FC<FormikDropdownProps> = ({
  name,
  options,
  label,
  placeholder,
  className,
  onChange,
}) => {
  const [field, meta, helpers] = useField(name);

  const selectId = `${name}-select`;

  const handleChange = (event: any) => {
    const value = event.target.value;
    helpers.setValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <FormControl fullWidth error={meta.touched && Boolean(meta.error)} className={className}>
      {label && <InputLabel id={`${selectId}-label`}>{label}</InputLabel>} {/* Label */}
      <Select
        labelId={`${selectId}-label`}
        id={selectId}
        {...field}
        onChange={handleChange}
        label={label}
        displayEmpty={!!placeholder}
      >
        {placeholder && (
          <MenuItem value="" disabled>
            {' '}
            {/* Placeholder seçeneği */}
            {placeholder}
          </MenuItem>
        )}
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {' '}
            {/* Seçenekler */}
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && <FormHelperText>{meta.error}</FormHelperText>}{' '}
      {/* Hata mesajı */}
    </FormControl>
  );
};
